export default "__VITE_ASSET__D0GZM6g9__"